import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { zodDeleteContractEndpointSchema } from './validations';

/**
 * Deletes a contract by its ID.
 * Soft deletes the contract only by setting its status to DELETED.
 *
 * @param contractId - The ID of the contract to delete.
 * @param options - Optional request options (e.g., abort signal).
 * @returns {Promise<void>} Resolves when the delete succeeds; the API returns no payload.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Contracts/operation/delete_contract_contracts__contract_id__delete
 */
export const deleteContract = async (
  contractId: UUID,
  options?: KyRequestOptions,
) => {
  await vestigasApi.delete(ENDPOINT.CONTRACT.DELETE(contractId), {
    validate: {
      pathSegments: zodDeleteContractEndpointSchema,
    },
    ...options,
  });
};
